import { useCallback } from 'react';

const SOUND_URL = '/sound.wav';

export const useSoundPlayer = () => {
  const onPlaySound = useCallback(async (volume = 70) => {
    try {
      // Ses dosyasını yükle ve çal
      const audio = new Audio(SOUND_URL);
      audio.volume = volume / 100; // Ses seviyesini ayarla (0-1 arası)

      // Ses yüklendiğinde çal
      audio.onloadeddata = () => {
        audio.play().catch(() => {
          // Ses çalma hatası durumunda sessizce devam et
        });
      };

      // Hata durumunda
      audio.onerror = () => {
        // Ses dosyası yüklenemedi durumunda sessizce devam et
      };

      // Eğer ses zaten yüklüyse direkt çal
      if (audio.readyState >= 2) {
        audio.play().catch(() => {
          // Ses çalma hatası durumunda sessizce devam et
        });
      }
    } catch (error) {
      // Ses çalma genel hatası durumunda sessizce devam et
    }
  }, []);

  return {
    onPlaySound,
    SOUND_URL,
  };
};
